import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Routes from './Routes';
import Hero from './Hero/Hero';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';
import helpers from './helpers';
import optionData from './helpers/optionData';
import Scrollchor from 'react-scrollchor';
import { office as officeActions } from '../../../store/actions';
import { initialState } from '../../../store/reducers';
import './Office.css';
import './Total/Total.css';

export class Office extends PureComponent {
    timeout = 0

    componentDidMount() {
        if (this.props.properties) {
            this.initializeComponent();
        }
    }
    initializeComponent = () => {
        // Only set initial office reducer values on first render
        if (JSON.stringify(this.props.office) === JSON.stringify(initialState.office)) {
            
            const { initPage, properties } = this.props;
            const visibleProperties = helpers.showAllMarkers(properties);
            const { regions, subMarkets } = helpers.getInitialOptions(properties);

            if (regions && subMarkets) {
                const payload = {
                    visibleProperties,
                    totalText: helpers.getTotalText(visibleProperties),
                    options: {
                        regions,
                        subMarkets,
                        projectTypes: optionData.projectType,
                        totalSqFts: optionData.totalSqFt,
                    },
                    maxSqFts: helpers.calculateMaxAvailableSqFt(properties),
                };

                initPage(payload);
            }
        }
    }

    handleKeywordChange = keyword => {
        const { properties, office: { options, filters }} = this.props;
        const searchResults = helpers.searchProperties(properties, keyword, filters);
        let newOptions;

        // Check if no results
        if (searchResults.length === 0) {
            newOptions = {
                regions: helpers.showAllOptions(options.regions),
                subMarkets: helpers.showAllOptions(options.subMarkets),
                projectTypes: helpers.showAllOptions(options.projectTypes),
                totalSqFts: helpers.showAllOptions(options.totalSqFts),
            };
        } else {
            newOptions = helpers.getAvailableOptions(searchResults, options);
        }

        const payload = {
            visibleProperties: searchResults,
            totalText: helpers.getTotalText(searchResults),
            keyword,
            options: newOptions,
        };

        this.props.keywordSearch(payload);
        this._searching.simulateClick();
    }

    handleFilterChange = (name, value, label, region = null) => {
        const { keyword, options, filters } = this.props.office;

        const pathname = this.props.history.location.pathname;
        
        // Check if no change
        if (filters[name] !== null && filters[name].value === value) return;

        const newFilters = helpers.getNewFilter(name, value, label, region, filters);
        const searchResults = helpers.searchProperties(this.props.properties, keyword, filters);
        const availableOptions = helpers.getAvailableOptions(searchResults, options);
        const newOptions = helpers.getNewOptions(name, value, options, availableOptions, newFilters);

        const payload = {
            visibleProperties: searchResults,
            totalText: helpers.getTotalText(searchResults),
            options: newOptions,
            filters: newFilters,
        };
 
        if (name === 'availableSqFt') {
            if (!pathname.includes('office/list')){
                this.props.history.push('/office/list');
            }
        }

        this.props.applyFilter(payload);
        this._searching.simulateClick();
    }

    handleMapOver = (propertyId, infoWindowId) => {
        if (propertyId && infoWindowId) {
            if (propertyId !== infoWindowId) {
                this.props.mapChange({ propertyId:'',  infoWindowId: '' });
            }
        }
    }

    handleMapClick = (propertyId, infoWindowOpen = false) => {
        const payload = {
            infoWindowId: infoWindowOpen ? propertyId : '',
            propertyId: propertyId ? propertyId : '',
        };

        this.props.mapChange(payload);
    }

    searchMap = (visibleMapProperties, zoom, center) => {
        const visibleMarkers = visibleMapProperties.filter(property => property.showMarker);
        const useProperties = visibleMarkers.length === 0
            ? helpers.showAllMarkers(this.props.properties)
            : visibleMarkers;
        const availableOptions = helpers.getAvailableOptions(useProperties, this.props.office.options);
        const payload = {
            visibleProperties: visibleMapProperties,
            totalText: helpers.getTotalText(useProperties),
            availableOptions,
            map: {
                zoom,
                center,
                propertyId: '', // clear
                infoWindowId: '', // clear
            },
        };

        this.props.mapSearch(payload);
    }

    clear = () => {
        const { properties, office: { options }} = this.props;
        const visibleProperties = helpers.showAllMarkers(properties);
        const payload = {
            visibleProperties,
            totalText: helpers.getTotalText(visibleProperties),
            options: {
                regions: helpers.showAllOptions(options.regions),
                subMarkets: helpers.showAllOptions(options.subMarkets),
                projectTypes: helpers.showAllOptions(options.projectTypes),
                totalSqFts: helpers.showAllOptions(options.totalSqFts),
            },
        };

        this.props.reset(payload);
    }

    render() {
        const { screen, location, history } = this.props;
        const { visibleProperties, keyword, filters, options, maxSqFts, totalText, map } = this.props.office;
        const currentPath = location.pathname.split('/office')[1];
        const showSearch = [ '', '/', '/list', '/map' ].includes(currentPath);
        const filtersOff = Object.values(filters).every(filter => filter === null);
        const filterMapOff = map.zoom === initialState.office.map.zoom || map.center === initialState.office.map.center; // map has not been zoomed or panned

        return (
            <div>
                {showSearch && <div className="office-view">
                    <Scrollchor ref={ref => (this._searching = ref)} to="_searching" disableHistory={true} animate={{ duration: 250, offset: -78 }}></Scrollchor>
                    <Hero
                        isDesktop={screen.isDesktop}
                        currentPath={currentPath} />
                    {screen.isDesktop
                        ? <HeaderDesktop
                            currentPath={currentPath}
                            keyword={keyword}
                            filters={filters}
                            filtersOff={filtersOff && keyword === '' && filterMapOff}
                            options={options}
                            maxSqFts={maxSqFts}
                            totalText={totalText}
                            handleKeywordChange={this.handleKeywordChange}
                            handleFilterChange={this.handleFilterChange}
                            handleClear={this.clear}
                        />
                        : <HeaderMobile
                            currentPath={currentPath}
                            keyword={keyword}
                            filters={filters}
                            filtersOff={filtersOff}
                            filterMapOff={filterMapOff}
                            options={options}
                            maxSqFts={maxSqFts}
                            totalText={totalText}
                            handleKeywordChange={this.handleKeywordChange}
                            handleFilterChange={this.handleFilterChange}
                            handleClear={this.clear}
                        />
                    }
                </div>}
                <Routes
                    screen={screen}
                    properties={visibleProperties}
                    filters={filters}
                    filtersOff={filtersOff}
                    filterMapOff={filterMapOff}
                    handleClear={this.clear}
                    map={map}
                    searchMap={this.searchMap}
                    handleMapClick={this.handleMapClick}
                    handleMapOver={this.handleMapOver}
                    currentPath={currentPath}
                    history={history}
                />
            </div>
        );
    }
}

Office.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object.isRequired,
    screen: PropTypes.shape({
        width: PropTypes.number.isRequired,
        isDesktop: PropTypes.bool.isRequired,
    }),
    properties: PropTypes.arrayOf(
        PropTypes.shape({
            order: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            city: PropTypes.string.isRequired,
            state: PropTypes.string.isRequired,
            web_photos: PropTypes.arrayOf(PropTypes.string).isRequired,
            thumbnail: PropTypes.string,
            slug: PropTypes.string.isRequired,
            rba: PropTypes.number.isRequired,
            region: PropTypes.string.isRequired,
            submarket: PropTypes.string.isRequired,
            in_service: PropTypes.bool.isRequired,
            development: PropTypes.bool.isRequired,
            redevelopment: PropTypes.bool.isRequired,
            repositioning: PropTypes.bool.isRequired,
        })
    ),
    office: PropTypes.shape({
        visibleProperties: PropTypes.array,
        keyword: PropTypes.string,
        filters: PropTypes.shape({
            region: PropTypes.object,
            subMarket: PropTypes.object,
            projectType: PropTypes.object,
            totalSqFt: PropTypes.object,
            availableSqFt: PropTypes.object,
        }),
        options: PropTypes.shape({
            regions: PropTypes.array,
            subMarkets: PropTypes.array,
            projectTypes: PropTypes.array,
            totalSqFts: PropTypes.array,
        }),
        maxSqFts: PropTypes.number,
        totalText: PropTypes.string,
        map: PropTypes.shape({
            zoom: PropTypes.number.isRequired,
            center: PropTypes.shape({
                lat: PropTypes.number,
                lng: PropTypes.number,
            }).isRequired,
            propertyId: PropTypes.string,
            infoWindowId: PropTypes.string,
        }),
    }),
    // Redux Actions
    initPage: PropTypes.func.isRequired,
    applyFilter: PropTypes.func.isRequired,
    keywordSearch: PropTypes.func.isRequired,
    mapChange: PropTypes.func.isRequired,
    mapSearch: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
};

export default connect(
    ({ screen, office, content }) => ({
        screen,
        office,
        /* istanbul ignore next */
        properties: content.properties && content.properties.length > 0
            // temporarily filter the properties
            // these fields can not be missing or else the search/filter breaks
            // currently, the api is sending office park properties that do not have these fields populated
            ? content.properties.filter(p => {
                return (p.order && p.order > 0)
                    && p.name
                    && p.city
                    && p.state
                    // QUESTION: filter for street_address?
                    && p.web_photos !== undefined
                    && p.thumbnail !== undefined
                    && p.slug
                    && p.rba !== undefined
                    && p.region
                    && (p.geo && p.geo[0] && p.geo[1])
                    && p.submarket
                    && p.in_service !== undefined
                    && p.development !== undefined
                    && p.redevelopment !== undefined
                    && !(!p.in_service && !p.development && !p.redevelopment && !p.repositioning)
                    && p.spaces;
            })
            : null,
    }),
    { ...officeActions }
)(Office);
